module.exports = __webpack_public_path__ + "static/img/PFK_Photo1_Slider_700x400_3.36743f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Photo1_Slider_700x400_3.jpg
// module id = 332
// module chunks = 2